import styles from './Spacer.module.scss';
import BuilderEditingHelper from '@common/BuilderEditingHelper/BuilderEditingHelper';

export default function Spacer() {
  return (
    <span className={styles.spacer} aria-hidden="true">
      <BuilderEditingHelper
        componentName="Spacer"
        visible={true}
        helperText="This 'blue bar' will be hidden on production."
      />
    </span>
  );
}
